<template>
    <div class="col-12 ">
        <div v-if="semiologia">
            <b-list-group class="my-1" horizontal>
                <b-row>
                    <b-col class="col-4" v-for="(valor, clave) in semiologia" :key="clave">
                        <b-list-group-item v-if="valor && clave !== 'analisis'">
                            <span v-if="clave === 'menarquia'"> Edad de menarquia: {{ valor }}</span>
                            <span v-if="clave === 'menopausia'"> Edad de menopausia: {{ valor }}</span>
                            <span v-if="clave === 'ciclos'"> Ciclos: {{ getCiclosLabel(valor) }}</span>
                            <span v-if="clave === 'inicioSexual'"> Inicio sexual: {{ valor }}</span>
                            <span v-if="clave === 'gestas'"> Gestas: {{ valor }}</span>
                            <span v-if="clave === 'partos'"> Partos: {{ valor }}</span>
                            <span v-if="clave === 'abortos'"> Abortos: {{ valor }}</span>
                            <span v-if="clave === 'cesareas'"> Cesareas: {{ valor }}</span>
                            <span v-if="clave === 'hijosVivos'"> Hijos Vivos: {{ valor }}</span>
                            <span v-if="clave === 'planificacionFamiliar'"> Planificacion familiar: {{ valor }}</span>
                            <span v-if="clave === 'terapiaHormonal'"> Terapia Hormonal: {{ valor }}</span>
                            <span v-if="clave === 'ultimaMenstruacion'"> Ultima Menstruacion: {{ valor }}</span>
                            <span v-if="clave === 'ultimoParto'"> Ultimo Parto: {{ valor }}</span>
                            <span v-if="clave === 'citologiaCervical'"> Citologia Cervical: {{ valor }}</span>
                            <span v-if="clave === 'colposcopia'"> Colposcopia: {{ valor }}</span>
                            <span v-if="clave === 'mamografia'"> Mamografia: {{ valor }}</span>
                            <span v-if="clave === 'antigenoProstatico'"> Antigeno Prostatico: {{ valor }}</span>
                            <span v-if="clave === 'ecoProstatico'"> Eco Prostatico: {{ valor }}</span>
                        </b-list-group-item>
                    </b-col>
                </b-row>
            </b-list-group>
            <span class="col-12" v-if="semiologia.analisis"> Analisis: {{ semiologia.analisis }}</span>
        </div>
        <div v-else>
            <span class="mt-1 ml-1 text-warning">No registra infromacion</span>
        </div>
    </div>
</template>
<script>
import { anamnesisService } from '@/views/atencionMedica/services';
export default {
    name: "AntGinecologicosTable",
    props: {
        tokenAtencion: {
            type: String,
            required: true
        },
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            semiologia: null,
        }
    },
    methods: {
        getCiclosLabel(valor) {
            if (String(valor) === '1') return 'Regular';
            if (String(valor) === '2') return 'Irregular';
            return valor;
        },
        async loadData() {
            if (!this.tokenAtencion) return;
            let query_semio = await anamnesisService.getByAtencion(this.tokenAtencion);
            this.semiologia = query_semio?.semiologia?.data
        },
    },
    watch: {
        tokenAtencion: {
            deep: true,
            handler: 'loadData'
        },
    },
}
</script>
